<template>
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7701_5037)">
      <path
        d="M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z"
        fill="#3B6D95"
        fill-opacity="0.08"
      />
      <mask
        id="mask0_7701_5037"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="20"
        height="21"
      >
        <path
          d="M21 11.5L11 21.5M11 11.5L21 21.5"
          stroke="black"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_7701_5037)">
        <rect
          x="6"
          y="6.5"
          width="20"
          height="20"
          fill="#091620"
          fill-opacity="0.8"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7701_5037">
        <path
          d="M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
